export default "/images/4b984854154ca1919971a227f315cf9d.avif";